import { createFileRoute, Link } from '@tanstack/react-router'
import { PlusIcon } from 'lucide-react'

import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'
import { MeetingPollsList } from '@/components/meetings/meeting-polls-list'
import { Button } from '@/components/ui/button'

export const Route = createFileRoute('/_app/clients/$clientId/rendez-vous')({
  component: ClientMeetingPollsPage,
})

/** Les demandes de rendez-vous du client (lot 26). */
function ClientMeetingPollsPage() {
  const client = useShellClient()
  return (
    <Frame>
      <div className="flex justify-end">
        <Button asChild>
          <Link to="/clients/$clientId/rendez-vous/nouvelle" params={{ clientId: client.id }}>
            <PlusIcon />
            Nouvelle demande de rendez-vous
          </Link>
        </Button>
      </div>
      <MeetingPollsList
        params={{ client_id: client.id, page_size: 50 }}
        empty="Aucune demande de rendez-vous pour ce client."
      />
    </Frame>
  )
}
